
import { supabase } from "@/lib/supabase";
import { findOrCreateProfile } from "./userProfileService";

// Helper to clean up expired verification codes
export const cleanupExpiredCodes = () => {
  // This is now handled by the database's RLS policies and triggers
};

// Generate a random verification code
export const generateVerificationCode = (): string => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

// Send login code via email
export const sendLoginCodeEmail = async (email: string, fullName: string, code: string): Promise<void> => {
  try {
    console.log("Calling send-verification-code function with:", { email, fullName, codeLength: code?.length });
    
    // The supabase.functions.invoke method automatically includes the authorization header
    const { error } = await supabase.functions.invoke('send-verification-code', {
      body: { email, fullName, code }
    });

    if (error) {
      console.error("Error invoking send-verification-code:", error);
      throw error;
    }
    
    console.log("Verification code sent successfully");
  } catch (error) {
    console.error("Exception in sendLoginCodeEmail:", error);
    throw error;
  }
};

// Verify a login code
export const verifyCode = async (email: string, code: string): Promise<boolean> => {
  try {
    console.log("Verifying code in authService:", email, code);
    
    // We need to use the rpc method to call the database function
    const { data, error } = await supabase.rpc('verify_login_code', { 
      p_email: email, 
      p_code: code 
    });

    if (error) {
      console.error("Error verifying code:", error);
      return false;
    }

    // If the code is valid, ensure a profile exists
    if (data) {
      try {
        // Get the full name from verification_codes if available
        const { data: userData } = await supabase
          .from('verification_codes')
          .select('full_name')
          .eq('email', email)
          .maybeSingle();
          
        // Create or update the profile
        await findOrCreateProfile(email, userData?.full_name || '');
      } catch (profileError) {
        console.error("Error ensuring profile exists:", profileError);
        // Don't block the login if profile creation fails
      }
    }

    console.log("Verification result:", data);
    return !!data;
  } catch (error) {
    console.error("Error in verification process:", error);
    return false;
  }
};
